import React, { useRef, useState } from 'react';

import { ApIcon, ApPopover } from '@alixpartners/ui-components';
import {
	CategoryIconWrapper,
	CategoryLine,
	CategoryLevel,
	CategoryTitle,
	Cell,
	PopoverContent,
} from './CategoriesCellRenderer.styles';

export const CategoriesCellRenderer = params => {
	const ref = useRef(null);
	const [isTooltipOpen, setTooltipOpen] = useState(false);

	const toggleOpen = () => setTooltipOpen(!isTooltipOpen);

	if (!params.data.l4Category || params.data.l4Category === '-') {
		return '';
	}

	return (
		<React.Fragment>
			<Cell
				innerRef={ref}
				onMouseOver={() => setTooltipOpen(true)}
				onMouseLeave={() => setTooltipOpen(false)}
			>
				<CategoryIconWrapper>
					<ApIcon iconName="outline_list_alt" />
				</CategoryIconWrapper>
			</Cell>
			{isTooltipOpen && (
				<ApPopover
					referenceElement={ref.current}
					onClose={toggleOpen}
					placement="top"
					modifiers={{
						preventOverflow: {
							enabled: false,
							boundariesElement: 'window',
							escapeWithReference: true,
						},
						hide: {
							enabled: false,
						},
					}}
				>
					<PopoverContent>
						<CategoryLine>
							<CategoryLevel>L1</CategoryLevel>
							&nbsp;
							<CategoryTitle>{params.data.l1Category}</CategoryTitle>
						</CategoryLine>
						{params.data.l2Category && (
							<CategoryLine>
								<CategoryLevel>L2</CategoryLevel>
								&nbsp;
								<CategoryTitle>{params.data.l2Category}</CategoryTitle>
							</CategoryLine>
						)}
						{params.data.l3Category && (
							<CategoryLine>
								<CategoryLevel>L3</CategoryLevel>
								&nbsp;
								<CategoryTitle>{params.data.l3Category}</CategoryTitle>
							</CategoryLine>
						)}
						{params.data.l4Category && (
							<CategoryLine>
								<CategoryLevel>L4</CategoryLevel>
								&nbsp;
								<CategoryTitle>{params.data.l4Category}</CategoryTitle>
							</CategoryLine>
						)}
					</PopoverContent>
				</ApPopover>
			)}
		</React.Fragment>
	);
};

export default CategoriesCellRenderer;
